import { c as _c } from "react/compiler-runtime";
import { SVGProps } from "react";
export const ArrowDropDown = properties => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#arrow-drop-down_svg__a)"><path d="m7 10 5 5 5-5H7Z" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <defs><clipPath id="arrow-drop-down_svg__a"><path d="M0 0h24v24H0z" /></clipPath></defs>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== properties) {
    t2 = <svg height="1em" viewBox="0 0 24 24" width="1em" xmlns="http://www.w3.org/2000/svg" {...properties}>{t0}{t1}</svg>;
    $[2] = properties;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};